import getOption from '@/src/utils/getOption';
import Accordion from '@components/Accordion';
import { useTranslations } from 'next-intl';

export default function RoadAdminInfo({
  vegvesen,
  vegvesenjson,
}: {
  vegvesen: string | null;
  vegvesenjson: string | null;
}) {
  const t = useTranslations('RoadAdminInfo');
  if (!vegvesen && !vegvesenjson) {
    return null;
  }
  let json = null;
  if (vegvesenjson) {
    try {
      vegvesenjson = JSON.parse(vegvesenjson);
    } catch (e) {
      vegvesenjson = null;
    }
  }
  if (!vegvesen && !vegvesenjson) {
    return null;
  }
  if (vegvesenjson) {
    json = (
      <>
        {Object.keys(vegvesenjson).map((key) => {
          return (
            <div key={key} className='flex border-b border-[#333] py-2'>
              <span className='w-1/2 font-bold'>
                {t(key)}
              </span>{' '}
              <span>
                {vegvesenjson && String(vegvesenjson[key as keyof typeof vegvesenjson])}
              </span>
            </div>
          );
        })}
      </>
    );
  }

  return (
    <Accordion
      title={t(
        `infoFromRoadAdministration${String(getOption('DEFAULT_LOCALE')).toUpperCase()}`
      )}
    >
      {json}
      <pre style={{ font: 'inherit' }}>{vegvesen}</pre>
    </Accordion>
  );
}
